<template>
    <div class="card-video block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_video_round.png" alt="">
                        </div>
                        <h4>Video URL</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <p>Allows to send a video file in the chat. Supported format: MP4. Maximum file size: ~20 MB. If you use Dropbox, please replace "www" at the beginning of the video file URL with "dl".
                        Example: https://dl.dropbox.com/s/sample.mp4</p>
                    <label> URL </label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.url"-->
<!--                            :error="!data.url || !common.validURL(data.url)"-->
<!--                            :error-messages="!data.url? 'URL is Required':'' || !common.validURL(data.url)? 'URL is not valid':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.url" :type="'textfield'"
                                           :validationRules="autocompleteVideoValidationRules"></vTextareaAutocomplete>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-image-url",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                autocompleteVideoValidationRules: [
                    v => !!v || 'Url is Required'
                ]
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>